import {Component, ViewChild, ViewEncapsulation} from "@angular/core";
import {StateService} from "./service/state";
import {TranslateService} from "@ngx-translate/core";
import {LoginDialogComponent} from "./components/login/login.dialog";
import {ApiService} from "./service/api";
import {User} from "./data/user";
import {CartService} from "./service/cart";
import {MatDialog, MatSidenav} from "@angular/material";
import {Angulartics2Piwik} from "angulartics2/piwik";

declare var $: any;
declare var lightbox: any;

@Component({
    selector: 'fw-app',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './app.component.html',
    styleUrls: [
        './app.component.scss'
    ]
})
export class AppComponent {
    public searchHidden: boolean = true;
    public mainMenu: any = [{
        name: 'home',
        title: 'Home',
        icon: 'home',
        link: '/home'
    }, {
        name: 'admin',
        title: 'Admin',
        icon: 'sliders',
        link: '/admin',
        sub: []
    }];

    public activeMenu: any;

    public user: User;

    @ViewChild('adminmenu') adminMenu: MatSidenav;

    constructor(public state: StateService,
                public cart: CartService,
                public translate: TranslateService,
                public api: ApiService,
                public dialog: MatDialog,
                public analytics: Angulartics2Piwik) {

        state.getState('defaultLang').then(defaultLang => {
            translate.setDefaultLang(defaultLang);
            translate.addLangs(['en', 'de']);
            state.getLanguage().then(lang => {
                translate.use(lang);
            })
        });

        this.api.call('index/login/index', {}).then((result) => {
            let user: User = result;
            if(!user.username) {
                this.state.setState('user', undefined);
            }else{
                this.state.setState('user', user);
            }
        })

        state.watchState('user').subscribe(user => {
            this.user = user;
        });

        state.getState('user').then(user => {
            this.user = user;
        })
    }

    showLogin() {
        let dialogRef = this.dialog.open(LoginDialogComponent, {
            disableClose: true
        }).afterClosed()
    }

    logout() {
        this.api.call('index/login/logout').then((result) => {
            this.state.setState('user', undefined);
        })
    }

    toggleSidenav() {
        this.adminMenu.toggle();
    }

    toggleSidenavMenu(menuItem: any, isSub: boolean) {
        if (!isSub) {
            this.activeMenu = this.activeMenu === menuItem ? null : menuItem;
            return;
        }

        if (isSub) {
            if (this.adminMenu.mode === 'push' ||
                this.adminMenu.mode === 'over') {
                this.toggleSidenav();
            }
            return;
        }

        this.activeMenu = null;
        if (this.adminMenu.mode === 'push' ||
            this.adminMenu.mode === 'over') {
            this.toggleSidenav();
        }
    }

    ngAfterViewInit() {
        // Component views are initialized
        $('#loader').removeClass('shown');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts